function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M256.001,221.868c10.761,0,20.13-4.045,25.6-7.049c5.47,3.004,14.839,7.049,25.6,7.049 c15.889,0,33.647-9.028,41.233-20.864c0.751-1.135,18.5-28.262,18.5-73.003c0-32.939-26.795-59.733-59.733-59.733 c-9.651,0-18.449,3.541-25.6,7.305c-7.151-3.763-15.949-7.305-25.6-7.305c-32.939,0-59.733,26.795-59.733,59.733 c0,50.56,15.727,70.204,19.149,73.865C223.13,211.577,238.968,221.868,256.001,221.868z M256.001,85.335 c7.612,0,15.394,3.942,21.325,7.381c2.645,1.536,5.905,1.536,8.55,0c5.931-3.439,13.713-7.381,21.325-7.381 c23.526,0,42.667,19.14,42.667,42.667c0,39.27-15.488,63.317-15.718,63.659c-3.985,6.212-16.026,13.141-26.948,13.141 c-10.999,0-20.446-6.801-20.506-6.844c-1.51-1.126-3.302-1.69-5.094-1.69s-3.584,0.563-5.094,1.69 c-0.094,0.068-9.506,6.844-20.506,6.844c-10.871,0-22.221-7.091-27.383-13.756c-0.171-0.222-0.461-0.546-0.657-0.751 c-0.145-0.154-14.626-16.026-14.626-62.293C213.334,104.475,232.474,85.335,256.001,85.335z"
}), React.createElement("path", {
  d: "M274.288,55.596c1.596,2.662,4.42,4.139,7.322,4.139c1.493,0,3.012-0.393,4.386-1.22 c4.036-2.423,5.35-7.663,2.918-11.708l-25.6-42.667c-2.424-4.036-7.663-5.35-11.708-2.918c-4.036,2.423-5.35,7.663-2.918,11.708 L274.288,55.596z"
}), React.createElement("path", {
  d: "M300.929,54.367c0.597,0.196,6.042,1.946,13.244,1.946h0.009c10.206,0,19.081-3.482,25.643-10.052 c15.616-15.616,8.414-37.956,8.098-38.904c-0.853-2.543-2.85-4.54-5.393-5.393c-0.606-0.196-6.05-1.946-13.261-1.946 c-10.206,0-19.072,3.473-25.643,10.044c-15.616,15.625-8.405,37.956-8.098,38.904C296.38,51.517,298.377,53.514,300.929,54.367z M315.691,22.128c3.345-3.345,7.91-5.043,13.577-5.043c1.203,0,2.338,0.077,3.345,0.196c0.521,4.599,0.282,11.776-4.855,16.913 c-3.345,3.345-7.919,5.052-13.577,5.052c-1.203,0-2.338-0.085-3.345-0.196C310.315,34.442,310.554,27.265,315.691,22.128z"
}), React.createElement("path", {
  d: "M486.401,238.935h-409.6c-14.114,0-25.6,11.486-25.6,25.6v34.133c0,4.71,3.823,8.533,8.533,8.533 s8.533-3.823,8.533-8.533v-34.133c0-4.702,3.831-8.533,8.533-8.533h25.6v42.667c0,4.71,3.823,8.533,8.533,8.533 s8.533-3.823,8.533-8.533v-42.667h221.867v42.667c0,4.71,3.823,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-42.667h85.333v42.667 c0,4.71,3.823,8.533,8.533,8.533c4.71,0,8.533-3.823,8.533-8.533v-42.667h25.6c4.702,0,8.533,3.831,8.533,8.533v59.733h-25.6 c-4.71,0-8.533,3.823-8.533,8.533v76.8h-8.533c-4.71,0-8.533,3.823-8.533,8.533c0,4.71,3.823,8.533,8.533,8.533h25.6v59.733 c0,4.702-3.831,8.533-8.533,8.533H204.801v-42.667c0-4.71-3.823-8.533-8.533-8.533s-8.533,3.823-8.533,8.533v42.667h-17.067 v-42.667c0-4.71-3.823-8.533-8.533-8.533c-4.71,0-8.533,3.823-8.533,8.533v42.667h-17.067v-42.667 c0-4.71-3.823-8.533-8.533-8.533s-8.533,3.823-8.533,8.533v42.667h-76.8c-4.702,0-8.533-3.831-8.533-8.533v-34.133 c0-4.71-3.823-8.533-8.533-8.533c-4.71,0-8.533,3.823-8.533,8.533v34.133c0,14.114,11.486,25.6,25.6,25.6h426.667 c14.114,0,25.6-11.486,25.6-25.6v-59.733c0-11.085-8.789-17.067-17.067-17.067v-68.267h17.067 c8.277,0,17.067-5.982,17.067-17.067v-59.733C512.001,250.421,500.515,238.935,486.401,238.935z"
}), React.createElement("path", {
  d: "M332.801,426.668c4.71,0,8.533-3.823,8.533-8.533c0-4.71-3.823-8.533-8.533-8.533h-93.867v-68.267h119.467v128 c0,3.149,1.732,6.042,4.506,7.526c2.765,1.476,6.144,1.314,8.764-0.427l20.864-13.909l20.864,13.909 c1.434,0.956,3.081,1.434,4.736,1.434c1.382,0,2.765-0.333,4.028-1.007c2.773-1.485,4.506-4.378,4.506-7.526v-128h8.533 c4.71,0,8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533h-409.6c-14.353,0-25.6,11.247-25.6,25.6v51.2 c0,14.114,11.486,25.6,25.6,25.6H332.801z M375.467,341.335h34.133v112.051l-12.331-8.218c-2.867-1.911-6.605-1.911-9.472,0 l-12.331,8.218V341.335z M102.401,341.335h119.467v68.267H102.401V341.335z M17.067,401.068v-51.2 c0-4.864,3.669-8.533,8.533-8.533h59.733v68.267H25.601C20.814,409.602,17.067,405.855,17.067,401.068z"
}), React.createElement("path", {
  d: "M179.201,358.401c-4.71,0-8.533,3.823-8.533,8.533v17.067c0,4.71,3.823,8.533,8.533,8.533s8.533-3.823,8.533-8.533 v-17.067C187.734,362.224,183.911,358.401,179.201,358.401z"
}), React.createElement("path", {
  d: "M145.067,358.401c-4.71,0-8.533,3.823-8.533,8.533v17.067c0,4.71,3.823,8.533,8.533,8.533 c4.71,0,8.533-3.823,8.533-8.533v-17.067C153.601,362.224,149.778,358.401,145.067,358.401z"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      "enableBackground": "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/books.36771145.svg";
export { SvgComponent as ReactComponent };